import { OrgConfigContext, OrgConfigProvider } from "./OrgConfigProvider";
import { OrgConfig } from "../types";

export type { OrgConfig };
export { OrgConfigContext, OrgConfigProvider };
